export const uniqByKey = <T extends Record<string, any>>(
  arr: T[],
  key: keyof T
): T[] => {
  const uniqueComputedValues = new Set(arr.map((item) => item[key]));

  const result = arr.filter((value) => {
    const computedValue = value[key];

    // Remove this computed value so it will not match again
    if (uniqueComputedValues.has(computedValue)) {
      uniqueComputedValues.delete(computedValue);
      return true; // Keep this item
    }

    return false; // Discard this item
  });

  return result;
};
